import React, { useEffect, useState } from 'react';
import routes from 'js/core_pre_webpack/routes';
import { Icon } from 'js/design_system/Icon';
import { ImpressionWatcher } from 'js/utils/impressions/ImpressionWatcher';
import {
  GreenDot,
  IconAnchor,
  IconLabel,
  RelativeIconContainer,
} from './buttonStyles';

export const GREEN_DOT_STORAGE_KEY = 'impact_hub_v2_visited';

const ImpactNavButton: React.FC = () => {
  const [showGreenDot, setShowGreenDot] = useState(true);

  useEffect(() => {
    const hasVisitedImpactHubV2 = localStorage.getItem(GREEN_DOT_STORAGE_KEY);
    if (hasVisitedImpactHubV2) {
      setShowGreenDot(false);
    }
  }, []);

  return (
    <ImpressionWatcher key="impact" source="impact_hub.nav">
      <IconAnchor
        href={routes.impact_home_url({ from_navbar: true, trigger: 'nav' })}
      >
        <RelativeIconContainer>
          <Icon name="whatshot" size={24} />
          {showGreenDot && <GreenDot />}
        </RelativeIconContainer>
        <IconLabel>Impact</IconLabel>
      </IconAnchor>
    </ImpressionWatcher>
  );
};

export default ImpactNavButton;
